import { baseUrl } from "util/APIBaseUrl";

/** The portal's own login (customer, employee, Edge user), kept apart from the PLG session. */
const PORTAL_SESSION_KEYS = ["accessToken", "refreshToken", "loggedInUser", "permissionTable"];

/** A portal login (customer, employee, Edge user) is present in this browser. */
export function hasPortalSession(): boolean {
  try {
    return !!localStorage.getItem("accessToken");
  } catch {
    return false;
  }
}

/**
 * QA ON-6: a PLG sign-in or sign-up starts a clean session. Any portal login still in this browser is
 * revoked (best effort) and removed, so the site root never opens someone else's dashboard afterwards.
 */
export function endPortalSession(): void {
  let refreshToken: string | null = null;
  try {
    if (!PORTAL_SESSION_KEYS.some((k) => localStorage.getItem(k) !== null)) return;
    refreshToken = localStorage.getItem("refreshToken");
    PORTAL_SESSION_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch {
    return;
  }
  if (!refreshToken || typeof fetch !== "function") return;
  fetch(`${baseUrl}/logout/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken }),
  }).catch(() => undefined);
}
